import { Label } from "@xola/ui-kit";
import { JsDateRange, now } from "common";
import React, { useState } from "react";
import { XolaBotAssistType, XolaBotAssistTypeCopy } from "types";
import shallow from "zustand/shallow";
import { getInitialDate } from "../../../models/Reports";
import { useXolaBotEarningsReportFilterStore } from "../../../stores/reports/xolabotEarningsReportFilterStore";
import { ListFilter } from "../../Dashboard/Filters/ListFilter";
import { ItemSummary } from "../AnalyticsProductPicker";
import { ReportDatePicker } from "../ReportDatePicker";

export const XolaBotEarningsReportFilter = () => {
    const [from, to] = useXolaBotEarningsReportFilterStore((state) => [state.getFrom(), state.getTo()], shallow);
    const [setFrom, setTo] = useXolaBotEarningsReportFilterStore((state) => [state.setFrom, state.setTo], shallow);
    const [filters, setFilters] = useXolaBotEarningsReportFilterStore(
        (state) => [state.filters, state.setFilters],
        shallow,
    );

    const [value, setValue] = useState(getInitialDate(from, to));
    const handleDateChange = (dateValue: JsDateRange) => {
        if (dateValue.from && dateValue.to) {
            setFrom(now(dateValue.from));
            setTo(now(dateValue.to));
        }

        setValue(dateValue);
    };

    return (
        <div className="flex flex-row items-center justify-between border-b border-gray-light px-6 py-3">
            <div className="flex w-full flex-row items-center justify-between">
                <div className="flex w-full flex-row items-center justify-start space-x-1 xl:space-x-4">
                    <Label>Purchase Date</Label>
                    <div>
                        <ReportDatePicker
                            from={from}
                            to={to}
                            value={value}
                            disabledDays={() => false}
                            onChange={handleDateChange}
                        />
                    </div>

                    <div>
                        <ListFilter
                            label="Assist Type"
                            title="Filter Assist Type"
                            target={ItemSummary}
                            fetch={fetchAssistTypes}
                            value={filters.assistTypes}
                            onChange={(assistTypes) => setFilters({ assistTypes })}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const fetchAssistTypes = () => {
    const assistTypes: Array<{ name: string; id: XolaBotAssistType }> = Object.values(XolaBotAssistType).map(
        (type) => ({ name: XolaBotAssistTypeCopy[type], id: type }),
    );

    return { data: assistTypes, isLoading: false };
};
